var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('a',{attrs:{"href":_vm.href},on:{"click":function($event){return _vm.$emit('btn-click')}}},[_vm._t("default")],2):_c('button',{on:{"click":function($event){return _vm.$emit('btn-click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }